<template>
    <el-container class="container">
        <el-aside width='auto'>
            <el-scrollbar>
                <SideBar :collapse="collapse"></SideBar>
            </el-scrollbar>
        </el-aside>
        <el-container class="container">
            <el-header>
                <Nav @on-collapse="collapse = $event"></Nav>
            </el-header>
            <el-main>
                <el-scrollbar class="index-page">
                    <router-view></router-view>
                </el-scrollbar>
                <el-backtop target=".index-page .el-scrollbar__wrap"></el-backtop>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import Nav from '@/components/Nav';
    import SideBar from '@/components/SideBar';

    export default {
        components: {
            Nav,
            SideBar,
        },
        data() {
            return {
                collapse: false,
            }
        },
        mounted() {
            if (this.$route.path === "/index") {
                if (this.$root.user.type === 'USER') {
                    location.href = this.$root.services[0]['path'];
                } else {
                    this.$router.push(this.$root.menus[0]['path']);
                }
            }
        }
    }
</script>

<style scoped>
    .container {
        height: 100%;
    }

    .el-aside {
        background-color: #2f4050;
    }

    .el-header {
        box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
        background-color: #fff;
        height: 56px !important;
        line-height: 56px;
        padding: 0 10px;
    }

    .el-main {
        padding: 10px;
    }

    .popover {
        position: absolute;
        top: 0;
        right: 10px
    }

    .popover .el-button {
        margin-top: 5px;
        margin-left: 0;
        display: block;
    }
</style>
<style>
    .el-scrollbar {
        height: 100%;
    }

    .el-aside .el-scrollbar__wrap, .el-main .el-scrollbar__wrap:first-child, .el-drawer__content .el-scrollbar__wrap {
        overflow-x: hidden !important;
    }

    .el-scrollbar__bar.is-horizontal {
        display: none;
    }

    .el-drawer, .el-drawer__container {
        outline: none;
    }

    .el-drawer__body {
        padding: 20px;
    }

    .el-drawer__content {
        height: calc(100vh - 70px);
    }

    .el-drawer__footer button {
        margin: 5px 0;
        width: 48%;
    }

    .el-drawer__footer button:last-child {
        float: right;
    }

    .el-page-header {
        margin-bottom: 20px;
    }

    .el-dialog__body {
        padding: 0 20px 30px 20px;
    }

    .el-card {
        margin-bottom: 10px;
    }

    .el-card.active {
        box-shadow: 0 2px 12px 0 #a83839;
    }

    .el-form-item.text {
        margin-bottom: 10px;
    }

    .el-form-item.text .el-form-item__content, .el-form-item.text .el-form-item__label {
        line-height: 25px;
    }

    .pull-right {
        float: right !important;
    }

    a {
        color: #606266;
        text-decoration: none;
    }

    .clear {
        clear: both;
    }

    .help-text {
        color: #909399;
        font-size: 13px;
        line-height: 30px;
        margin: 0;
    }

    .m-t {
        margin-top: 10px;
    }

    dl {
        margin-top: 0;
        margin-bottom: 20px;
        overflow: hidden;
        line-height: 2.0;
    }

    .dl-horizontal dt {
        float: left;
        width: 110px;
        overflow: hidden;
        clear: left;
        text-align: right;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 600;
    }

    .dl-horizontal dd {
        margin-left: 120px;
        min-height: 32px;
    }
</style>